const formSwiperAutoScroll = (scrollableNodeId?: string) => {
  const swiperWrapper = document.getElementById(scrollableNodeId ?? 'formSwiperScrollable');
  if (swiperWrapper) {
    swiperWrapper.scrollTo({ top: 0, behavior: 'smooth' });
  }
};

export default formSwiperAutoScroll;